import { Container, useMediaQuery } from '@mui/material';
import FrontChat from 'components/FrontChat';
import { Header } from 'components/Header';
import { QuoteStepperWithContextWrapper } from 'components/QuoteStepper';
import theme from 'providers/theme/theme';
import type { FC, ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  displayChatWidget?: boolean;
}

const ExtendedLayout: FC<IProps> = ({ children, displayChatWidget = false }) => {
  const isTabletLayout = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Header displayPhoneNumber={false} displaySaveAndExit displayChatWidget={displayChatWidget} />

      {displayChatWidget && <FrontChat />}

      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          minHeight: `calc(100dvh - ${theme.customStyling.appBar.height})`,
          mt: theme.customStyling.appBar.height,
          px: '0px !important',
          pb: 3,
        }}
      >
        {!isTabletLayout && (
          <Container
            maxWidth="sm"
            sx={{
              pt: 3,
              mb: 6,
            }}
          >
            <QuoteStepperWithContextWrapper />
          </Container>
        )}

        {children}
      </Container>
    </>
  );
};

export default ExtendedLayout;
